import React from "react";
import Form from "./Form";
import { FormattedMessage } from "react-intl";
import { APP_VERSION } from "../../constants";

const Login = () => {
  return (
    <div className="h-full flex">
      <div
        className="bg-cover bg-center bg-no-repeat w-[60%]"
        style={{
          backgroundImage: "url(/images/home.png)",
        }}
      ></div>
      <div className="w-[40%] flex flex-col">
        <img
          src="/images/logo.svg"
          alt="liu.jo logo"
          className="w-[100px] mx-auto mt-10 mb-5"
        />

        <div className="flex-grow flex justify-center items-center">
          <div className="w-[80%] mx-auto max-w-[1600px]">
            <h1 className="font-bold text-3xl">
              <FormattedMessage
                id="reset_password"
                defaultMessage={"Reset Password"}
              />
            </h1>
            <Form />
          </div>
        </div>

        <footer className="text-black/70 pb-10 flex-shrink-0 flex justify-center items-center">
          {APP_VERSION}
          {/* -{" "} */}
          {/* <FormattedMessage id="development" defaultMessage={"Development"} /> */}
        </footer>
      </div>
    </div>
  );
};

export default Login;
